import * as apisPortal from '/@src/client-portal/api'
import { useUserSession } from '/@src/stores/userSession'

export default () => {
  const userSession = useUserSession()
  const locationURL = location.protocol + '//' + location.host

  const logout = async () => {
    const logoutUser = new apisPortal.PortalAuthApi()
    const refresh_token = localStorage.getItem('refresh_token') as string
    const locationURL = location.protocol + '//' + location.host
    await logoutUser.logoutPortalAuth(refresh_token, locationURL).then(async (response: any) => {
      userSession.setToken('')
      localStorage.setItem('access_token', '')
      localStorage.setItem('refresh_token', '')
      window.location.replace(response.data.url + '/callback' + '&id_token_hint=' + localStorage.getItem('id_token_hint'))
      localStorage.setItem('id_token_hint', '')
    })
  }

  const logoutWithoutRedirect = async () => {
    const logoutUser = new apisPortal.PortalAuthApi()
    const refresh_token = localStorage.getItem('refresh_token') as string
    await logoutUser.logoutPortalAuth(refresh_token)
    userSession.setToken('')
    localStorage.setItem('access_token', '')
    localStorage.setItem('refresh_token', '')
    localStorage.setItem('id_token_hint', '')
  }

  const refreshCurrentTokken = async () => {
    const authApi = new apisPortal.PortalAuthApi()
    const refreshToken = localStorage.getItem('refresh_token') as string
    await authApi
      .refreshTokenPortalAuth(refreshToken, {
        headers: {
          Authorization: '',
        },
      })
      .then((refreshTokenResponse) => {
        localStorage.setItem('access_token', refreshTokenResponse.data.access_token)
        localStorage.setItem('refresh_token', refreshTokenResponse.data.refresh_token)
        localStorage.setItem('id_token_hint', refreshTokenResponse.data?.id_token)
      })
  }

  const toLoginForm = async () => {
    const toLoginPage = new apisPortal.PortalAuthApi()

    await toLoginPage
      .loginPortalAuth(locationURL + '/callback')
      .then(async (response: any) => {
        window.location.replace(response.data.url)
      })
      .catch((error: any) => {
        console.log(error)
      })
  }

  return { logout, logoutWithoutRedirect, refreshCurrentTokken, toLoginForm }
}
